<template>
  <!-- <div class="p-fluid">
    <div class="p-col-12 p-lg-12"> -->
      <!-- <div class="card card-w-title"> -->
        <!-- <div class="group-permission-title">{{ title }}</div> -->
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit
          :key="componentKey"
          :mode="mode"
          @back="backToList"
          :model="models"/>
      <!-- </div> -->
    <!-- </div>
  </div> -->
</template>

<script>
// import gql from "graphql-tag";
// import Config from '../../../config/index'
// import DataServices from '@/core/DataServices'
import formEdit from './add'
import store from '@/store'
export default {
  components: {
    formEdit
  },
  data() {
    return {
      validationErrors: [],
      title: "Thêm văn phòng",
      mode: 'add',
      models: {},
      images: [],
      oldImages: [],
      componentKey: 0
    }
  },
  async mounted () {
    this.mode = this.$route.name === 'editoffice_tpl' ? 'edit' : this.mode;
    // this.title = this.mode === 'edit' ? 'Chỉnh sửa ngày nghỉ' : this.title;
    if (this.mode == 'add') {
      if (store.getters.group_permission && store.getters.group_permission.list_office.add == false && store.getters.role != "admin") {
        this.$router.push({name: '404'})
      }
    } else {
      if (store.getters.group_permission && store.getters.group_permission.list_office.edit == false && store.getters.role != "admin") {
        this.$router.push({name: '404'})
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-office_tpl' });
    },
  },
  apollo: {
  }
}
</script>

<style lang="scss">
.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only { padding: 0 !important; }
  }
}
.note{ letter-spacing: 0px; color: #707070; margin-bottom: 24px; padding-top: 10px;}
.p-formgrid { margin: 0;
  .p-panel-header {color: #000000; font-size: 18px; font-weight: bold; background: #EEEEEE;}
  .p-card-field{ padding: 24px;
    .p-field{
      .p-col-fixed { width: 300px; display: inline-block !important; margin: 0;}
      .p-col-width{width:450px !important; border-radius: 5px;
        &.disabled{background: #EEEEEE; border: 0 none; padding: 8px 10px;}
        .file-select{margin: 0;
          input[type="file"]{display: none;}
          .select-button{display: inline-block; cursor: pointer; background: transparent; border-radius: 5px;  color: #000000; font-size: 13px; padding: 3px 16px;  border: 1px solid #B4B4B4;}
        }
        &.pac-target-input{ height: 80px;  word-break: break-all; overflow-wrap: break-word;}
      }
      .box-images{ margin-top: 10px; position: relative;
        .item-img{height: 150px;  margin-right: 8px; margin-bottom: 8px; display: inline-flex; position: relative; border: 0.5px solid #ccc;
          &.p-col-5{width: 18%;;}
          img{max-width: 100%; height: auto;margin: 0 auto; object-fit: contain;}
          .button-clear{width: 18px; height: 18px; background: #F5564E; float: right; cursor: pointer; position: absolute; right: 0px;
            img{vertical-align: top;}
          }
        }
      }
      .p-invalid{display: block;}
    }
  }
  .fixed-bottom-toolbar{background: transparent; border: 0 none; padding: 0;
    .p-button{width: auto; margin-right: 8px;
      &:last-child{margin-right: 0;}
    }
  }
}
.group-permission-title {
    font-weight: bold;    
    font-size: 22px;
    padding-bottom: 10px;
    border-bottom: 1px solid #B4B4B4;
}
</style>